<template>
  <AppNavbar />
  <div class="container mt-5">
    <AppHeader title="Gestión de Facturas">
      <template #buttons>
        <router-link class="btn btn-success me-2" :to="{ name: 'RegistrarFactura' }">Registrar Factura</router-link>
      </template>
    </AppHeader>


    <AppFilter v-model="searchInput" placeholder="Buscar por número de comprobante o proveedor..." customClasses="mt-4 mb-4">
    </AppFilter>


    <!-- Tabla de Comprobantes -->
    <h2>Lista de Facturas</h2>
    <table class="table table-striped">
      <thead>
        <tr>
          <th>N° de Comprobante</th>
          <th>Proveedor</th>
          <th>Fecha</th>
          <th>Monto Total</th>
          <th>Estado</th>
          <th>Tipo de Comprobante</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(comprobante, index) in comprobantesFiltradosPaginados" :key="index">
          <td>{{ comprobante.nro_comprobante || 'N/A' }}</td>
          <td>{{ comprobante.nombre_razon_social || 'N/A' }}</td>
          <td>{{ formatearFecha(comprobante.fecha_emision) }}</td>
          <td>{{ formatearMonto(Math.trunc(comprobante.total_iva_incluido) || Math.trunc(comprobante.total_sin_iva)) || 'N/A' }}</td>
          <td>{{ comprobante.estado }}</td>

          <td>Factura</td>
          <td>
            <button class="btn btn-primary btn-sm me-1" @click="verDetalleComprobante(comprobante)">Ver</button>
            <button class="btn btn-danger btn-sm me-1" :disabled="comprobante.estado === 'anulado'" @click="anularComprobante(comprobante)">Anular</button>
          </td>
        </tr>
      </tbody>
    </table>


    <!-- Controles de Paginación -->
    <AppPagination :currentPage="paginaActual" :totalPages="totalPaginas" @page-changed="cambiarPagina" />
  </div>
</template>

<script>
import ApiServices from '../services/apiService.js';
import AppNavbar from '../components/AppNavbar.vue';
import AppHeader from '../components/AppHeader.vue';
import AppFilter from '../components/AppFilter.vue';
import AppPagination from '../components/AppPagination.vue';

export default {
  name: 'ListarComprobantes',
  components: {
    AppNavbar,
    AppHeader,
    AppFilter,  
    AppPagination 
  },
  data() {
    return {
      comprobantes: [],
      searchInput: '',
      paginaActual: 1,
      itemsPorPagina: 5
    };
  },
  computed: {
    comprobantesFiltrados() {
      return this.comprobantes.filter(comprobante => {
        const numero = (comprobante.nro_comprobante || '').toLowerCase();
        const proveedor = (comprobante.nombre_razon_social || '').toLowerCase();
        return numero.includes(this.searchInput.toLowerCase()) || proveedor.includes(this.searchInput.toLowerCase());
      });
    },
    comprobantesFiltradosPaginados() {
      const start = (this.paginaActual - 1) * this.itemsPorPagina;
      const end = start + this.itemsPorPagina;
      return this.comprobantesFiltrados.slice(start, end);
    },
    totalPaginas() {
      return Math.ceil(this.comprobantesFiltrados.length / this.itemsPorPagina);
    }
  },
  methods: {
    async cargarComprobantes() {
      try {
        const response = await ApiServices.get(`${process.env.VUE_APP_API_BASE_URL}/api/purchases/invoices`);
        const facturas = response.data.data || [];
        facturas.forEach(factura => {
          factura.tipo = 'factura';
        });
        this.comprobantes = facturas;
      } catch (error) {
        console.error('Error al cargar facturas:', error);
      }
    },
    setFiltroTipo(tipo) {
      this.filtroTipo = tipo;
      this.paginaActual = 1;
    },
    cambiarPagina(page) {
      this.paginaActual = page;
    },
    formatearMonto(monto) {
      if (monto === undefined || monto === null) return "0";
      return Number(Math.round(monto)).toLocaleString('es-PY', { minimumFractionDigits: 0 });
    },
    formatearFecha(fecha) {
      if (!fecha) return 'N/A';
      // Convierte de formato ISO (YYYY-MM-DD) o (YYYY-MM-DDTHH:MM:SS) a DD/MM/YYYY
      const fechaObj = new Date(fecha);
      const dia = String(fechaObj.getDate()).padStart(2, '0');
      const mes = String(fechaObj.getMonth() + 1).padStart(2, '0');
      const anio = fechaObj.getFullYear();
      return `${dia}/${mes}/${anio}`;
    },
    actualizarListaComprobantes() {
      this.paginaActual = 1;
    },
    async anularComprobante(comprobante) {
      const confirmed = await confirm({
        message: '¿Está seguro de que desea anular este comprobante?',
        title: 'Anular comprobante',
        confirmText: 'Anular',
        cancelText: 'Cancelar'
      });
      if (!confirmed) return;

      try {
        await ApiServices.delete(
          `${process.env.VUE_APP_API_BASE_URL}/api/purchases/invoices/${comprobante.nro_comprobante}`
        );
        comprobante.estado = 'anulado';
  alert.success('Comprobante anulado correctamente.');
        await this.cargarComprobantes();
      } catch (error) {
        console.error('Error al anular comprobante:', error);
  alert.error('No se pudo anular el comprobante. Por favor, intente de nuevo.');
      }
    },
    verDetalleComprobante(comprobante) {
      console.log("Tipo: factura");
      this.$router.push({ name: 'Factura', params: { id: comprobante.nro_comprobante } });
    },
  // Funcionalidades de impresión deshabilitadas temporalmente
  },
  async mounted() {
    await this.cargarComprobantes();
  }
};
</script>

<style scoped>
/* Estilos generales */
.container {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
h1, h2 {
  color: #343a40;
}
.form-label {
  font-weight: bold;
  color: #495057;
}
</style>
